import {Action, handleActions} from "redux-actions";
import {QuoteState} from "./QuoteState";
import {QUOTE_DETAILS_FETCHED, QUOTE_FINANCE_PRODUCT_UPDATED} from "../../action/quote/actionType";
import {option} from "ts-option";

const initState: QuoteState = {
	quotesMap: {},
};

const reducer = handleActions({
	[QUOTE_DETAILS_FETCHED]: (state: QuoteState, action: Action<any>): QuoteState => {
		return {
			...state, quotesMap: {
				...state.quotesMap,
				[action.payload.quoteDetails.id]: action.payload.quoteDetails
			}
		}
	},
	[QUOTE_FINANCE_PRODUCT_UPDATED]: (state: QuoteState, action: Action<QUOTE_FINANCE_PRODUCT_UPDATED>) => {
		const updatedQuoteDetails =
			state.quotesMap[action.payload.quoteId].copy({financeProductId: option(action.payload.financeProductId)});
		return {
			...state, quotesMap: {
				...state.quotesMap,
				[action.payload.quoteId]: updatedQuoteDetails
			}
		}
	}
}, initState);

export default reducer;
